// Rates travel as decimal strings - a fraction of assets per year, "0.0025" for
// 0.25% - and are edited as percentages. Converting by moving the point within
// the string, rather than through Number, keeps 0.35% from coming back as
// 0.0034999999999999996.

const PLAIN_NUMBER = /^(?:\d+\.?\d*|\.\d+)$/

/** A rate as a percentage for editing. An unknown rate is blank, not zero. */
export function rateToPercent(rate: string | null): string {
  if (rate === null) {
    return ""
  }

  return shiftPoint(rate, 2)
}

/** Parses a typed percentage. Blank is no rate; anything unparseable throws. */
export function percentToRate(percent: string): string | null {
  const trimmed = percent.trim().replace(/%$/, "").trim()
  if (trimmed === "") {
    return null
  }

  if (!PLAIN_NUMBER.test(trimmed)) {
    throw new Error(`“${percent}” is not a percentage`)
  }

  return shiftPoint(trimmed, -2)
}

export function formatRate(rate: string | null): string {
  return rate === null ? "--" : `${rateToPercent(rate)}%`
}

function shiftPoint(value: string, places: number): string {
  const [whole, fraction = ""] = value.split(".")

  let digits = whole + fraction
  let point = whole.length + places

  if (point < 0) {
    digits = "0".repeat(-point) + digits
    point = 0
  }
  if (point > digits.length) {
    digits = digits + "0".repeat(point - digits.length)
  }

  const integer = digits.slice(0, point).replace(/^0+/, "") || "0"
  const decimals = digits.slice(point).replace(/0+$/, "")

  return decimals === "" ? integer : `${integer}.${decimals}`
}
